import * as React from 'react';
import styles from './Aside.module.scss';

export const Aside = ({ children }: { children: React.ReactNode }) => <aside className={styles.Aside}>{children}</aside>;
